module.exports = __webpack_public_path__ + "static/media/appointment-creating.4d3b1a50.svg";